// Typed accessors over the static game data in /data (bundled at build time).
import metaJson from "../../../data/meta.json";
import workshopJson from "../../../data/workshop.json";
import uwsJson from "../../../data/uws.json";
import labsJson from "../../../data/labs.json";
import cardsJson from "../../../data/cards.json";
import relicsJson from "../../../data/relics.json";
import modulesJson from "../../../data/modules.json";
import type {
  Card,
  GameDataMeta,
  Lab,
  ModuleRarity,
  Relic,
  UltimateWeapon,
  WorkshopEnhancement,
  WorkshopStat,
} from "./types";

export const meta = metaJson as GameDataMeta;

export const workshopStats = (workshopJson as { stats: WorkshopStat[] }).stats;
export const workshopEnhancements = (
  workshopJson as { enhancements: { items: WorkshopEnhancement[] } }
).enhancements.items;

export const ultimateWeapons = (uwsJson as { weapons: UltimateWeapon[] }).weapons;
export const uwUnlockCosts = (uwsJson as { unlock: { costByPurchaseOrder: number[] } }).unlock
  .costByPurchaseOrder;

export const labs = (labsJson as { labs: Lab[] }).labs;

export const cards = (cardsJson as { cards: Card[] }).cards;
export const cardSlotCosts = (cardsJson as { slotCostsGems: number[] }).slotCostsGems;

export const relics = (relicsJson as { relics: Relic[] }).relics;

export const moduleRarities = (modulesJson as { rarities: ModuleRarity[] }).rarities;
export const moduleLevelCosts = (
  modulesJson as { levelCosts: { shards: number[]; coins: number[] } }
).levelCosts;

const byId = <T extends { id: string }>(items: T[]) =>
  new Map(items.map((item) => [item.id, item]));

export const workshopById = byId(workshopStats);
export const uwById = byId(ultimateWeapons);
export const labById = byId(labs);
export const cardById = byId(cards);
export const relicById = byId(relics);
